// extracted by mini-css-extract-plugin
module.exports = {"SDropDownWrapper":"DropDownMenu_SDropDownWrapper__RHlzR","SMenuItems":"DropDownMenu_SMenuItems__G5WS0","SMenuItem":"DropDownMenu_SMenuItem__wzYni"};